module.exports = __webpack_public_path__ + "img/header-empty-list-dark.ec8031c7.svg";